/**
 * Module dependencies.
 */

import { useMemo } from 'react';
import useTranslate from 'src/hooks/use-translate';

/**
 * Export `Chronology` type.
 */

export type Chronology = {
  description: string;
  quote?: string;
  year: string;
};

/**
 * Export `chronologyItems`.
 */

export function useChronologyItems(): Chronology[] {
  const { translate } = useTranslate();

  const items = useMemo(() => {
    return [
      {
        description: translate(
          'biography-saramago:chronologySection.chronologyList.item1.description'
        ),
        quote: translate(
          'biography-saramago:chronologySection.chronologyList.item1.quote'
        ),
        year: '1922'
      },
      {
        description: translate(
          'biography-saramago:chronologySection.chronologyList.item2.description'
        ),
        year: '1947'
      },
      {
        description: translate(
          'biography-saramago:chronologySection.chronologyList.item3.description'
        ),
        year: '1950’s'
      },
      {
        description: translate(
          'biography-saramago:chronologySection.chronologyList.item4.description'
        ),
        year: '1971'
      },
      {
        description: translate(
          'biography-saramago:chronologySection.chronologyList.item5.description'
        ),
        year: '1976'
      },
      {
        description: translate(
          'biography-saramago:chronologySection.chronologyList.item6.description'
        ),
        year: '1995-98'
      },
      {
        description: translate(
          'biography-saramago:chronologySection.chronologyList.item7.description'
        ),
        year: '2007'
      }
    ];
  }, [translate]);

  return items;
}

/**
 * Export `ChronologyImage` type.
 */

export type ChronologyImage = {
  imageTitle: string;
  imageUrl: string;
  legend?: string;
};

/**
 * Export `chronologyImages`.
 */

export function useChronologyImages(): ChronologyImage[] {
  const { translate } = useTranslate();

  const items = useMemo(() => {
    return [
      {
        imageTitle: 'José Saramago',
        imageUrl: '/images/saramago-chronology/saramago1.jpg'
      },
      {
        imageTitle: 'José Saramago',
        imageUrl: '/images/saramago-chronology/saramago2.jpg'
      },
      {
        imageTitle: 'José Saramago',
        imageUrl: '/images/saramago-chronology/saramago3.jpg'
      },
      {
        imageTitle: 'José Saramago',
        imageUrl: '/images/saramago-chronology/saramago4.jpg',
        legend: translate(
          'biography-saramago:chronologySection.chronologyList.image4.legend'
        )
      }
    ];
  }, [translate]);

  return items;
}
